import React from "react";
import { Col, Row } from "antd";
import { Link } from "react-router-dom";
import "./FooterComponent.scss";
import { IS_ENABLED_SUPPORT_CENTER_MODULE } from "../../../constants";

const FooterComponent = () => {
  return (
    <footer className="new_footer_area bg_color">
      <div className="new_footer_top nw-bckgnd">
        <div className="gx-container">
          <Row>
            <Col xl={6} lg={6} md={6} sm={24} xs={24}>
              <div>
                <h3 className="f-title f_600 t_color f_size_18">
                  About Tradesbarn
                </h3>
                <ul
                  className="list-unstyled mmgnnftr"
                  style={{ marginBottom: "25px" }}
                >
                  <li>
                    <Link
                      to="/customer-service/company-info-and-policy"
                      className="ftr-ancr"
                    >
                      Company Information and Policy
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/customer-service/accepted-payments-policy"
                      className="ftr-ancr"
                    >
                      Accepted Payment Policy
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/customer-service/intellectual-property-pules"
                      className="ftr-ancr"
                    >
                      Intellectual Property Rules
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/customer-service/real-estate-policy"
                      className="ftr-ancr"
                    >
                      Real Estate Policy
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/customer-service/tax-policy"
                      className="ftr-ancr"
                    >
                      Tax Policy
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/customer-service/identity-screening-policy"
                      className="ftr-ancr"
                    >
                      TB Identity Screening Policy
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/customer-service/fraud-policy"
                      className="ftr-ancr"
                    >
                      Tradesbarn Fraud Policy
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/customer-service/online-advertising-policy"
                      className="ftr-ancr"
                    >
                      Tradesbarn Online Advertising Policy
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/customer-service/final-value-fees"
                      className="ftr-ancr"
                    >
                      Tradesbarn Seller Fees
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/customer-service/privacy-policy"
                      className="ftr-ancr"
                    >
                      Privacy Policy
                    </Link>
                  </li>
                </ul>
              </div>
            </Col>
            <Col xl={6} lg={6} md={6} sm={24} xs={24}>
              <div>
                <h3 className="f-title f_600 t_color f_size_18">Buy & Sell</h3>
                <ul
                  className="list-unstyled mmgnnftr"
                  style={{ marginBottom: "25px" }}
                >
                  <li>
                    <Link className="ftr-ancr" to="/register">
                      Register for Buying
                    </Link>
                  </li>
                  <li>
                    <Link className="ftr-ancr" to="/help/buyer">
                      Buying Information
                    </Link>
                  </li>
                  <li>
                    <Link className="ftr-ancr" to="/account/seller/register">
                      Register for Selling
                    </Link>
                  </li>
                  <li>
                    <Link className="ftr-ancr" to="/help/seller">
                      Selling Information
                    </Link>
                  </li>
                </ul>

                <h3 className="f-title f_600 t_color f_size_18">App</h3>
                <ul
                  className="list-unstyled mmgnnftr"
                  style={{ marginBottom: "25px" }}
                >
                  {/* footer image */}
                  <a
                    href="https://apps.apple.com/app/tradesbarn-online-shopping/id1538334605"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      alt="footer"
                      style={{ width: 100 }}
                      src={require("../../../assets/images/appleapp.png")}
                      // onClick={() => history.push("https://apps.apple.com/app/tradesbarn-online-shopping/id1538334605")}
                    />
                  </a>
                  <a
                    href="https://play.google.com/store/apps/details?id=com.tradesbarn.app"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      alt="footer"
                      style={{ width: 100 }}
                      src={require("../../../assets/images/googleplay.png")}
                    />
                  </a>
                </ul>
              </div>
            </Col>
            <Col xl={6} lg={6} md={6} sm={24} xs={24}>
              <div>
                <h3 className="f-title f_600 t_color f_size_18">Help</h3>
                <ul
                  className="list-unstyled mmgnnftr"
                  style={{ marginBottom: "25px" }}
                >
                  {IS_ENABLED_SUPPORT_CENTER_MODULE && (
                    <li>
                      <Link
                        className="ftr-ancr"
                        to="/support-center/buyer-registration"
                      >
                        Support Center
                      </Link>
                    </li>
                  )}
                  <li>
                    <Link className="ftr-ancr" to="/resolution-center/all">
                      Resolution Center
                    </Link>
                  </li>
                  <li>
                    <Link className="ftr-ancr" to="/term-and-conditions">
                      Terms &amp; Conditions
                    </Link>
                  </li>
                  <li>
                    <Link className="ftr-ancr" to="/help-and-contact">
                      Contact Us
                    </Link>
                  </li>
                </ul>
              </div>
              <h3 className="f-title f_600 t_color f_size_18">Verified By</h3>
              <div style={{ marginBottom: "25px" }}>
                <img
                  alt="website security"
                  title="SiteLock"
                  border="0"
                  style={{ width: "70px" }}
                  src="//shield.sitelock.com/shield/tradesbarn.com"
                />
                <span
                  className="AuthorizeNetSeal"
                  style={{ marginLeft: "10px" }}
                >
                  <a
                    target="_blank"
                    href="https://verify.authorize.net/anetseal/?pid=c849a8d7-00d0-4158-8287-e9b1ccc5ba07&rurl=https://www.tradesbarn.com"
                    rel="noopener noreferrer"
                  >
                    <img
                      alt="img-footer"
                      style={{ width: "60px" }}
                      src="https://verify.authorize.net/anetseal/images/secure90x72.gif"
                    />
                  </a>
                </span>
              </div>
            </Col>
            <Col xl={6} lg={6} md={6} sm={24} xs={24}>
              <div>
                <h3 className="f-title f_600 t_color f_size_18">
                  Social Media
                </h3>

                <div className="social-container">
                  <ul className="social-icons">
                    <li>
                      <a
                        href={process.env.REACT_APP_SOCIAL_MEDIA_FB}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fab fa-facebook-f"></i>
                      </a>
                    </li>
                    <li>
                      <a
                        href={process.env.REACT_APP_SOCIAL_MEDIA_TWITTER}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fab fa-twitter"></i>
                      </a>
                    </li>
                    <li>
                      <a
                        href={process.env.REACT_APP_SOCIAL_MEDIA_LINKEDIN}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fab fa-linkedin"></i>
                      </a>
                    </li>
                    <li>
                      <a
                        href={process.env.REACT_APP_SOCIAL_MEDIA_INSTAGRAM}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fab fa-instagram"></i>
                      </a>
                    </li>
                    {/* <li>
                      <a
                        href="https://www.youtube.com/channel/UChipX2OXQhgLgto32w9T4WA"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fa fa-youtube"></i>
                      </a>
                    </li> */}
                    <li>
                      <a
                        href={process.env.REACT_APP_SOCIAL_MEDIA_PINTEREST}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fab fa-pinterest"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col xl={24} lg={24} md={24} sm={24} xs={24}>
              <div className="cprgt-bar">
                <p>{process.env.REACT_APP_FOOTER_COPYRIGHT_TEXT}</p>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </footer>
  );
};

export default FooterComponent;
